import React from 'react';
import { Button } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

class PageNotFound extends React.Component {
    render() {
        return (
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100vh',
                backgroundColor: '#f1f3f6',
                paddingLeft: '2rem',
                paddingRight: '2rem',
                textAlign: 'center'
            }}>
                <ErrorOutlineIcon style={{ fontSize: 100, color: '#2596be', marginBottom: '1rem' }} />
                <h1 style={{ fontSize: '3rem', color: '#333', marginBottom: '0.5rem' }}>
                    404 - Page Not Found
                </h1>
                <p style={{ fontSize: '1.2rem', color: '#666', maxWidth: '600px', marginBottom: '2rem' }}>
                    Oops! The page you’re looking for doesn’t exist or might have been moved. Let’s get you back on track.
                </p>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => window.location.href = '/'}
                    style={{
                        backgroundColor: '#2596be',
                        color: '#fff',
                        padding: '0.75rem 2rem',
                        fontSize: '1rem',
                        borderRadius: '8px'
                    }}
                >
                    Go to Homepage
                </Button>
            </div>
        );
    }
}

export default PageNotFound;
